import amazonlinuxIcon from "assets/onboarding/host/amazonlinux.svg";
import ansibleIcon from "assets/onboarding/host/ansible.svg";
import centosIcon from "assets/onboarding/host/centos.svg";
import chefIcon from "assets/onboarding/host/chef.svg";
import debianIcon from "assets/onboarding/host/debian.svg";
import kubernetesIcon from "assets/onboarding/host/kubernetes.svg";
import puppetIcon from "assets/onboarding/host/puppet.svg";
import redhatIcon from "assets/onboarding/host/redhat.svg";
import saltIcon from "assets/onboarding/host/salt.svg";
import ubuntuIcon from "assets/onboarding/host/ubuntu.svg";
import windowsIcon from "assets/onboarding/host/windows.svg";

import amazonlinuxInstructions from "./instructions/amazonlinux";
import ansibleInstructions from "./instructions/ansible";
import centosInstructions from "./instructions/centos";
import chefInstructions from "./instructions/chef";
import debianInstructions from "./instructions/debian";
import kubernetesInstructions from "./instructions/kubernetes";
import puppetInstructions from "./instructions/puppet";
import redhatInstructions from "./instructions/redhat";
import saltInstructions from "./instructions/salt";
import ubuntuInstructions from "./instructions/ubuntu";
import windowsInstructions from "./instructions/windows";

export const OPERATING_SYSTEMS = {
  amazonlinux: {
    name: "Amazon Linux",
    color: "#faaf34",
    icon: amazonlinuxIcon,
    instructions: amazonlinuxInstructions,
  },
  debian: {
    name: "Debian",
    color: "#a80030",
    icon: debianIcon,
    instructions: debianInstructions,
  },
  centos: {
    name: "CentOS",
    color: "#932279",
    icon: centosIcon,
    instructions: centosInstructions,
  },
  redhat: {
    name: "RHEL",
    color: "#c00",
    icon: redhatIcon,
    instructions: redhatInstructions,
  },
  ubuntu: {
    name: "Ubuntu",
    color: "#e95420",
    icon: ubuntuIcon,
    instructions: ubuntuInstructions,
  },
  windows: {
    name: "Windows",
    color: "#0DADEA",
    icon: windowsIcon,
    instructions: windowsInstructions,
  },
  kubernetes: {
    name: "Kubernetes",
    color: "#326de5",
    icon: kubernetesIcon,
    instructions: kubernetesInstructions,
  },
};

export const CONFIG_MANAGERS = {
  puppet: {
    name: "Puppet",
    color: "#ffae1a",
    icon: puppetIcon,
    instructions: puppetInstructions,
  },
  chef: {
    name: "Chef",
    color: "#405365",
    icon: chefIcon,
    instructions: chefInstructions,
  },
  ansible: {
    name: "Ansible",
    color: "#c00",
    icon: ansibleIcon,
    instructions: ansibleInstructions,
  },
  salt: {
    name: "Salt",
    color: "#100f0d",
    icon: saltIcon,
    instructions: saltInstructions,
  },
};
